export default __webpack_public_path__ + "static/media/SourceSansProExtraLight.7795b891.ttf";